import {useLayoutEffect} from "react";
import {useUserStore} from "../stores/userStore";
import {CircularProgress} from "@mui/material";

interface AuthCheckComponentProps {
    children: React.ReactNode
}

const AuthCheckComponent: React.FC<AuthCheckComponentProps> = ({children}) => {
    const userStore = useUserStore();

    useLayoutEffect(() => {
        if (!userStore.user) {
            userStore.login();
        }
    }, [userStore.user])

    if (userStore.status === "CHECKING") return <CircularProgress
        sx={{position: "absolute", left: "calc(50% - 20px)", top: "30%"}}/>;

    return <>
        {children}
    </>
}

export default AuthCheckComponent;